import React from 'react';
import Auth from '../Auth';
import { USER_ROLES } from '../../utilities/constants';

/**
 * @description 元請ユーザー専用トグル
 */
const PrimeContractorToggle = props => (
  <Auth
    approvedRoles={[USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.manager]}
  >
    {props.children}
  </Auth>
);

export default PrimeContractorToggle;



// WEBPACK FOOTER //
// ./src/components/toggle/PrimeContractorToggle.jsx